import { Route } from '@angular/router';
import { UiPageChromeConfig } from '@system-dyg/shared/ui';
import { crmLandingRoute } from './crm-route.helpers';

const SUPPORT_CRUMB = { id: 'support', label: 'Atención a clientes' };
const FAQ_CRUMB = {
  id: 'frequently-asked-questions',
  label: 'Preguntas frecuentes',
};
const CATALOGS_CRUMB = { id: 'catalogs', label: 'Catálogos' };
const REPORTS_CRUMB = { id: 'reports', label: 'Reportes' };

export const CRM_SUPPORT_ROUTES: Route[] = [
  crmLandingRoute({
    path: 'support/service-requests/service-requests',
    moduleId: 'support',
    activeMenubarId: 'sup-requests',
    title: 'Solicitudes de servicio',
    breadcrumbs: [
      SUPPORT_CRUMB,
      { id: 'service-requests', label: 'Solicitudes de servicio' },
    ],
    loadComponent: () =>
      import(
        '../pages/support/service-requests/service-requests/service-requests.component'
      ).then((m) => m.ServiceRequestsComponent),
  }),
  crmLandingRoute({
    path: 'support/users/users',
    moduleId: 'support',
    activeMenubarId: 'sup-users',
    title: 'Usuarios',
    breadcrumbs: [SUPPORT_CRUMB, { id: 'users', label: 'Usuarios' }],
    loadComponent: () =>
      import('../pages/support/users/users/support-users.component').then(
        (m) => m.SupportUsersComponent,
      ),
  }),
  crmLandingRoute({
    path: 'support/construction-progress/construction-progress',
    moduleId: 'support',
    activeMenubarId: 'sup-obra',
    title: 'Avances de obra',
    breadcrumbs: [
      SUPPORT_CRUMB,
      { id: 'construction-progress', label: 'Avances de obra' },
    ],
    loadComponent: () =>
      import(
        '../pages/support/construction-progress/construction-progress/construction-progress.component'
      ).then((m) => m.ConstructionProgressComponent),
  }),
  crmLandingRoute({
    path: 'support/surveys/surveys',
    moduleId: 'support',
    activeMenubarId: 'sup-surveys',
    title: 'Encuestas',
    breadcrumbs: [SUPPORT_CRUMB, { id: 'surveys', label: 'Encuestas' }],
    loadComponent: () =>
      import('../pages/support/surveys/surveys/surveys.component').then(
        (m) => m.SupportSurveysComponent,
      ),
  }),
  crmLandingRoute({
    path: 'support/frequently-asked-questions/questions',
    moduleId: 'support',
    activeMenubarId: 'sup-faq-questions',
    title: 'Preguntas',
    titleBarMode: 'data-table',
    breadcrumbs: [
      SUPPORT_CRUMB,
      FAQ_CRUMB,
      { id: 'questions', label: 'Preguntas' },
    ],
    loadComponent: () =>
      import(
        '../pages/support/frequently-asked-questions/questions/questions.component'
      ).then((m) => m.QuestionsComponent),
  }),
  crmLandingRoute({
    path: 'support/frequently-asked-questions/questions/new',
    moduleId: 'support',
    activeMenubarId: 'sup-faq-questions',
    title: 'Nueva pregunta',
    titleBarMode: 'form',
    breadcrumbs: [
      SUPPORT_CRUMB,
      FAQ_CRUMB,
      { id: 'questions', label: 'Preguntas' },
      { id: 'new', label: 'Nueva pregunta' },
    ],
    loadComponent: () =>
      import(
        '../pages/support/frequently-asked-questions/questions/question-form/question-form.component'
      ).then((m) => m.QuestionFormComponent),
  }),
  {
    path: 'support/frequently-asked-questions/questions/:questionId/edit',
    loadComponent: () =>
      import(
        '../pages/support/frequently-asked-questions/questions/question-edit/question-edit.component'
      ).then((m) => m.QuestionEditComponent),
    data: {
      chrome: {
        moduleId: 'support',
        activeMenubarId: 'sup-faq-questions',
        title: 'Editar pregunta',
        titleBarMode: 'form',
        breadcrumbItems: [
          { id: 'crm', label: 'CRM' },
          SUPPORT_CRUMB,
          FAQ_CRUMB,
          { id: 'questions', label: 'Preguntas' },
          { id: 'edit', label: 'Editar pregunta' },
        ],
      } satisfies UiPageChromeConfig,
    },
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'general' },
      {
        path: 'general',
        loadComponent: () =>
          import(
            '../pages/support/frequently-asked-questions/questions/question-edit/general/question-edit-general.component'
          ).then((m) => m.QuestionEditGeneralComponent),
      },
      {
        path: 'documents',
        loadComponent: () =>
          import(
            '../pages/support/frequently-asked-questions/questions/question-edit/documents/question-edit-documents.component'
          ).then((m) => m.QuestionEditDocumentsComponent),
      },
      {
        path: 'action-log',
        loadComponent: () =>
          import(
            '../pages/support/frequently-asked-questions/questions/question-edit/action-log/question-edit-action-log.component'
          ).then((m) => m.QuestionEditActionLogComponent),
      },
    ],
  },
  crmLandingRoute({
    path: 'support/frequently-asked-questions/categories',
    moduleId: 'support',
    activeMenubarId: 'sup-faq-categories',
    title: 'Categorías',
    titleBarMode: 'data-table',
    breadcrumbs: [
      SUPPORT_CRUMB,
      FAQ_CRUMB,
      { id: 'faq-categories', label: 'Categorías' },
    ],
    loadComponent: () =>
      import(
        '../pages/support/frequently-asked-questions/categories/categories.component'
      ).then((m) => m.CategoriesComponent),
  }),
  crmLandingRoute({
    path: 'support/frequently-asked-questions/categories/new',
    moduleId: 'support',
    activeMenubarId: 'sup-faq-categories',
    title: 'Nueva categoría',
    titleBarMode: 'form',
    breadcrumbs: [
      SUPPORT_CRUMB,
      FAQ_CRUMB,
      { id: 'faq-categories', label: 'Categorías' },
      { id: 'new', label: 'Nueva categoría' },
    ],
    loadComponent: () =>
      import(
        '../pages/support/frequently-asked-questions/categories/category-form/category-form.component'
      ).then((m) => m.CategoryFormComponent),
  }),
  {
    path: 'support/frequently-asked-questions/categories/:categoryId/edit',
    loadComponent: () =>
      import(
        '../pages/support/frequently-asked-questions/categories/category-edit/category-edit.component'
      ).then((m) => m.CategoryEditComponent),
    data: {
      chrome: {
        moduleId: 'support',
        activeMenubarId: 'sup-faq-categories',
        title: 'Editar categoría',
        titleBarMode: 'form',
        breadcrumbItems: [
          { id: 'crm', label: 'CRM' },
          SUPPORT_CRUMB,
          FAQ_CRUMB,
          { id: 'faq-categories', label: 'Categorías' },
          { id: 'edit', label: 'Editar categoría' },
        ],
      } satisfies UiPageChromeConfig,
    },
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'general' },
      {
        path: 'general',
        loadComponent: () =>
          import(
            '../pages/support/frequently-asked-questions/categories/category-edit/general/category-edit-general.component'
          ).then((m) => m.CategoryEditGeneralComponent),
      },
      {
        path: 'documents',
        loadComponent: () =>
          import(
            '../pages/support/frequently-asked-questions/categories/category-edit/documents/category-edit-documents.component'
          ).then((m) => m.CategoryEditDocumentsComponent),
      },
      {
        path: 'action-log',
        loadComponent: () =>
          import(
            '../pages/support/frequently-asked-questions/categories/category-edit/action-log/category-edit-action-log.component'
          ).then((m) => m.CategoryEditActionLogComponent),
      },
    ],
  },
  crmLandingRoute({
    path: 'support/catalogs/categories',
    moduleId: 'support',
    activeMenubarId: 'sup-cat-categories',
    title: 'Categorías',
    breadcrumbs: [
      SUPPORT_CRUMB,
      CATALOGS_CRUMB,
      { id: 'categories', label: 'Categorías' },
    ],
    loadComponent: () =>
      import('../pages/support/catalogs/categories/categories.component').then(
        (m) => m.SupportCategoriesComponent,
      ),
  }),
  crmLandingRoute({
    path: 'support/catalogs/processes',
    moduleId: 'support',
    activeMenubarId: 'sup-cat-processes',
    title: 'Procesos',
    breadcrumbs: [
      SUPPORT_CRUMB,
      CATALOGS_CRUMB,
      { id: 'processes', label: 'Procesos' },
    ],
    loadComponent: () =>
      import('../pages/support/catalogs/processes/processes.component').then(
        (m) => m.SupportProcessesComponent,
      ),
  }),
  crmLandingRoute({
    path: 'support/catalogs/types',
    moduleId: 'support',
    activeMenubarId: 'sup-cat-types',
    title: 'Tipos',
    breadcrumbs: [
      SUPPORT_CRUMB,
      CATALOGS_CRUMB,
      { id: 'types', label: 'Tipos' },
    ],
    loadComponent: () =>
      import('../pages/support/catalogs/types/types.component').then(
        (m) => m.SupportTypesComponent,
      ),
  }),
  crmLandingRoute({
    path: 'support/catalogs/activity-types',
    moduleId: 'support',
    activeMenubarId: 'sup-cat-activity-types',
    title: 'Tipos de actividades',
    breadcrumbs: [
      SUPPORT_CRUMB,
      CATALOGS_CRUMB,
      { id: 'activity-types', label: 'Tipos de actividades' },
    ],
    loadComponent: () =>
      import(
        '../pages/support/catalogs/activity-types/activity-types.component'
      ).then((m) => m.SupportActivityTypesComponent),
  }),
  crmLandingRoute({
    path: 'support/reports/service-requests',
    moduleId: 'support',
    activeMenubarId: 'sup-rep-requests',
    title: 'Solicitudes de servicio',
    breadcrumbs: [
      SUPPORT_CRUMB,
      REPORTS_CRUMB,
      { id: 'service-requests-report', label: 'Solicitudes de servicio' },
    ],
    loadComponent: () =>
      import(
        '../pages/support/reports/service-requests/service-requests-report.component'
      ).then((m) => m.ServiceRequestsReportComponent),
  }),
  crmLandingRoute({
    path: 'support/reports/construction-progress',
    moduleId: 'support',
    activeMenubarId: 'sup-rep-obra',
    title: 'Avances de obra',
    breadcrumbs: [
      SUPPORT_CRUMB,
      REPORTS_CRUMB,
      { id: 'construction-progress-report', label: 'Avances de obra' },
    ],
    loadComponent: () =>
      import(
        '../pages/support/reports/construction-progress/construction-progress-report.component'
      ).then((m) => m.ConstructionProgressReportComponent),
  }),
  crmLandingRoute({
    path: 'support/reports/users',
    moduleId: 'support',
    activeMenubarId: 'sup-rep-users',
    title: 'Usuarios',
    breadcrumbs: [
      SUPPORT_CRUMB,
      REPORTS_CRUMB,
      { id: 'users-report', label: 'Usuarios' },
    ],
    loadComponent: () =>
      import(
        '../pages/support/reports/users/support-users-report.component'
      ).then((m) => m.SupportUsersReportComponent),
  }),
];
